import { createContext } from 'react'

import { MysqlUsers } from '../graphqlTypes'

type MysqlUsersField = keyof MysqlUsers

type ReviewFilter = {
  categories: number[]
  column: MysqlUsersField
}

type UserAttributes = {
  categories: number[]
  columns: MysqlUsersField[]
}

type Context = {
  reviewFilters: ReviewFilter[]
  userAttributes: UserAttributes[]
}

const context: Context = {
  reviewFilters: [
    {
      categories: [2, 3, 4, 5, 49, 50],
      column: 'milk'
    },
    {
      categories: [8, 9, 12],
      column: 'youngest_child_weight'
    },
    {
      categories: [17],
      column: 'mother_birthday'
    },
    {
      categories: [22, 23],
      column: 'transport'
    },
    {
      categories: [24],
      column: 'mother_weight'
    },
    {
      categories: [25],
      column: 'car_model'
    }
  ],
  userAttributes: [
    {
      categories: [2, 3, 4, 5, 33, 47, 49, 50],
      columns: ['support_member', 'milk']
    },
    {
      categories: [6, 17, 48, 52, 54, 58, 59],
      columns: ['support_member']
    },
    {
      categories: [8, 9, 10],
      columns: ['youngest_child_height', 'youngest_child_weight', 'support_member', 'noise_care']
    },
    {
      categories: [12],
      columns: ['youngest_child_height', 'youngest_child_weight']
    },
    {
      categories: [13],
      columns: ['youngest_child_height', 'youngest_child_weight', 'residential_area', 'prefecture_id']
    },
    {
      categories: [14],
      columns: ['youngest_child_height', 'youngest_child_weight', 'residential_area']
    },
    {
      categories: [22, 23],
      columns: [
        'building_type',
        'floor_plan',
        'prefecture_id',
        'residential_area',
        'transport',
        'step_existence',
        'youngest_child_height',
        'youngest_child_weight',
        'support_member'
      ]
    },
    {
      categories: [24],
      columns: [
        'prefecture_id',
        'residential_area',
        'transport',
        'mother_height',
        'mother_weight',
        'youngest_child_height',
        'youngest_child_weight',
        'support_member'
      ]
    },
    {
      categories: [25],
      columns: [
        'prefecture_id',
        'residential_area',
        'transport',
        'car_model',
        'youngest_child_height',
        'youngest_child_weight',
        'support_member'
      ]
    },
    {
      categories: [30],
      columns: ['building_type', 'floor_plan', 'youngest_child_height', 'youngest_child_weight', 'support_member']
    },
    {
      categories: [31],
      columns: ['building_type', 'youngest_child_height', 'youngest_child_weight', 'support_member']
    },
    {
      categories: [41],
      columns: ['prefecture_id', 'residential_area', 'building_type']
    },
    {
      categories: [66],
      columns: ['support_member', 'building_type']
    },
    {
      categories: [68],
      columns: ['mother_height', 'mother_weight']
    },
    {
      categories: [77, 78],
      columns: ['prefecture_id', 'residential_area']
    },
    {
      categories: [80],
      columns: ['prefecture_id', 'residential_area', 'support_member']
    }
  ]
}

export default createContext(context)
